import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      login(data.token, data.user);
      toast.success(`Welcome ${data.user.name}! 20 free tokens are on us 🎁`);
      navigate("/");
    } catch (err) {
      const msg = formatApiErrorDetail(err.response?.data?.detail) || err.message || "Signup failed";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid-bg min-h-[calc(100vh-73px)] flex items-center">
      <div className="max-w-md w-full mx-auto px-6 py-16">
        <h1 className="font-display font-extrabold text-4xl tracking-tighter mb-2">Sign up</h1>
        <p className="text-zinc-500 text-sm mb-8">
          Get <span className="text-[#FBBF24] font-mono-nums">20 free tokens</span> to start
          bidding right now.
        </p>
        <form onSubmit={submit} className="card-surface p-6 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-zinc-500 mb-2 block">
              Name
            </label>
            <input
              type="text"
              required
              className="input-field"
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="register-name-input"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-zinc-500 mb-2 block">
              Email
            </label>
            <input
              type="email"
              required
              className="input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="register-email-input"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-zinc-500 mb-2 block">
              Password
            </label>
            <input
              type="password"
              required
              minLength={6}
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="register-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-bid w-full text-sm"
            data-testid="register-submit-button"
          >
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>
        <p className="text-zinc-500 text-sm mt-6 text-center">
          Already have an account?{" "}
          <Link to="/login" className="text-[#FBBF24] hover:underline">
            Log in
          </Link>
        </p>
      </div>
    </div>
  );
}
